import * as React from "react";
import { LocaleConfig, Locale, LocaleData } from "../types";

interface ContextData {
  provided: {
    onChangeLanguage: (s: Locale) => void;
    currentLocale: LocaleData;
    lang: Locale;
    i18nConfig: any;
    filteredAvailableLocales: LocaleConfig;
  };
}

const CurrentLangContext = React.createContext<ContextData | null>(null);

interface ICurrentLangProvider {
  children?: React.ReactNode;
  i18nConfig: any;
  lang: Locale;
  onChangeLanguage: (s: Locale) => void;
  filteredAvailableLocales: LocaleConfig;
}

const CurrentLangContextProvider: React.FC<ICurrentLangProvider> = ({
  children,
  i18nConfig,
  onChangeLanguage,
  lang,
  filteredAvailableLocales,
}) => {
  const [currentLocale, setCurrentLocale] = React.useState<LocaleData>(
    filteredAvailableLocales[lang],
  );

  React.useEffect(() => {
    setCurrentLocale(filteredAvailableLocales[lang]);
  }, [lang, filteredAvailableLocales]);

  const provided = React.useMemo(() => {
    return {
      onChangeLanguage,
      currentLocale,
      lang,
      i18nConfig,
      filteredAvailableLocales,
    };
  }, [lang, currentLocale, onChangeLanguage, i18nConfig, filteredAvailableLocales]);

  return <CurrentLangContext.Provider value={{ provided }}>{children}</CurrentLangContext.Provider>;
};

const useCurrentLangContext = () => React.useContext(CurrentLangContext);

export { CurrentLangContextProvider, useCurrentLangContext };
